import React, { useRef } from "react";
import { useUpdateEffect } from "ahooks";
import { useGroupUsersDispatch, useGroupUsersState } from "../Provider";
import { useGlobalState } from "../../../GlobalProvider";
import CategoryTree from "./CategoryTreeWrapper";

const Category = React.memo(() => {
  const tree = useRef(null);
  const {
    setCurrentGroup,
    updateCurrentGroup,
    setLoadingGroup
  } = useGroupUsersDispatch();
  const { reloadTreeFlag,currentCompanyId } = useGroupUsersState();

  const handleCheck = checkedKeys => {
    updateCurrentGroup({ id: checkedKeys });
  };

  const handleSetCurrentGroup = (keys, nodeInfo) => {
    setCurrentGroup(nodeInfo.node, true);
  };

  const handleLoaded = treeData => {
    setCurrentGroup(treeData[0], true);
  };

  const handleLoadFailed = () => {
    setLoadingGroup(false);
  };

  useUpdateEffect(() => {
    if (reloadTreeFlag) {
      tree.current?.reload(false);
    }
  }, [reloadTreeFlag]);

  return (
    <CategoryTree
      showCompany = {true}
      ref={tree}
      showSwitch={false}
      userMode
      readOnly
      collapse={false}
      onSelect={handleSetCurrentGroup}
      onCheck={handleCheck}
      onLoaded={handleLoaded}
      onLoadFailed={handleLoadFailed}
    />
  );
});

export default Category;
